export const depthDictionary = {
    sky: 1,
    moon: 2,
    mountains: 3,
    hills: 4,
    trees: 5,
    floor: 6,
    caveBehind: 10,
    stoneObstacle: 29,
    obstacle: 39,
    sheep: 39,
    player: 40,
    caveInFront: 45,
    chaser: 50,
    grass: 52,
    game2Bg: 20,
    brightnessOverlay: 10000,
    attention: 55,
    flares: 60,
    nameTag: 75,
    countdown: 80,
    game2Countdown: 10003,
    progressBox: 85,
    progressBar: 90,
    percentText: 95,
    game2Text: 10002,
    game2NameTag: 10001,
    game2PlayerOffset: 20,
    deadText: 100,
};
